import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";

const BackgroundShcema = (isEdit = false) =>
  Yup.object().shape({
    sport_id: Yup.string().label("Sport").required(),
    page: Yup.string().label("Page").required(),
    name: Yup.string().label("Name").required().max(255),
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
    image_url: Yup.mixed()
      .label("Image")
      .when([], {
        is: () => isEdit,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required(),
      }),
  });

export default BackgroundShcema;
